<template>
  <div>
    <TopMenu />
    <LeftMenu />
    <div class="app-content content container-fluid">
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import TopMenu from "@/components/TopMenu.vue";
import LeftMenu from "@/components/LeftMenu.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "AppContentContainer",
  props: {
    title: String,
  },
  components: {
    TopMenu,
    LeftMenu,
    Footer,
  },
};
</script>